import { type InputHTMLAttributes, forwardRef } from 'react';
import { inputVariants, type InputStyleProps } from './input-variants';

export type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> &
  InputStyleProps;

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, inputSize, invalid, fullWidth, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      className={inputVariants({ inputSize, invalid, fullWidth, className })}
      {...props}
    />
  );
});
